import { useState, useEffect } from "react"; // ✅ FIXED
import { FILE_BASE_URL } from "../services/api";
import "./CustomerModal.css";
import {
  getLocalDateTimeValue,
  parseDateTimeLocalValue
} from "../utils/dateTime";

export default function CustomerModal({
  showModal,
  setShowModal,
  form,
  setForm,
  files,
  setFiles,
  cars,
  availability,
  priceInfo,
  handleSubmit,
  formatDateFull,
  editId
}) {
  const [errors, setErrors] = useState({});
  const [minDateTime, setMinDateTime] = useState("");
  const [preview, setPreview] = useState(null); // For image preview
    

  // ✅ LOCAL TIME FUNCTION
  useEffect(() => {
    const updateTime = () => {
      setMinDateTime(getLocalDateTimeValue());
    };

    updateTime();

    const interval = setInterval(updateTime, 60000);

    return () => clearInterval(interval);
  }, []);

  if (!showModal) return null;

  // ✅ VALIDATION FUNCTION
  const validate = () => {
    let e = {};

    if (!form.fullName || form.fullName.trim().length < 3) {
      e.fullName = "Name must be at least 3 characters";
    }

    if (!form.phone) {
      e.phone = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.phone)) {
      e.phone = "Enter valid 10-digit Indian mobile number";
    }

    if (!form.car) {
      e.car = "Please select a car";
    }

    const now = new Date();
    const pickup = parseDateTimeLocalValue(form.pickupDate);
    const drop = parseDateTimeLocalValue(form.dropDate);

    if (!form.pickupDate) {
      e.pickupDate = "Please select a pickup date and time";
    } else if (!pickup) {
      e.pickupDate = "Please enter a valid pickup date and time";
    } else if (pickup < now) {
      e.pickupDate = "Pickup date and time cannot be in the past";
    }

    if (!form.dropDate) {
      e.dropDate = "Please select a drop date and time";
    } else if (!drop) {
      e.dropDate = "Please enter a valid drop date and time";
    } else if (pickup && drop <= pickup) {
      e.dropDate = "Drop date and time must be later than pickup";
    } else if (pickup && drop - pickup < 60 * 60 * 1000) {
      e.dropDate = "Minimum booking duration is 1 hour";
    }

    if (!form.amount) {
      e.amount = "Amount is required";
    } else if (form.amount <= 0) {
      e.amount = "Amount must be greater than 0";
    } else if (form.amount < 100) {
      e.amount = "Minimum amount should be ₹100";
    }

    // 🔥 ADVANCE AMOUNT VALIDATION
    if (form.advanceAmount !== "" && form.advanceAmount !== null && form.advanceAmount !== undefined) {
      const advanceNum = Number(form.advanceAmount);
      const totalNum = Number(priceInfo?.totalAmount || form.amount);

      if (advanceNum < 0) {
        e.advanceAmount = "Advance amount cannot be negative";
      } else if (advanceNum > totalNum) {
        e.advanceAmount = `Cannot exceed total amount (₹${totalNum})`;
      }
    }

    const allowed = ["image/jpeg", "image/png", "application/pdf"];
    const maxSize = 2 * 1024 * 1024;

    ["aadharFront", "aadharBack", "licence", "addressProof"].forEach(
      (key) => {
        const hasFile = files[key];
        const isExisting = hasFile?.isExisting;

        if (editId && isExisting) {
          return;
        }

        if (!hasFile) {
          e[key] = "This document is required";
        } else if (!isExisting) {
          if (!allowed.includes(hasFile.type)) {
            e[key] = "Only JPG, PNG or PDF allowed";
          }
          if (hasFile.size > maxSize) {
            e[key] = "File must be less than 2MB";
          }
        }
      }
    );

    setErrors(e);
    return Object.keys(e).length === 0;
  };
// const getLocalDateTime = () => {
//   const now = new Date();
//   const offset = now.getTimezoneOffset() * 60000;
//   const local = new Date(now - offset);
//   return local.toISOString().slice(0, 16);
// };
  // ✅ HANDLE SAVE
  const handleSave = () => {
    if (!validate()) return;

    if (availability?.status === "blocked") {
      setErrors((currentErrors) => ({
        ...currentErrors,
        general: "This car is already booked for the selected time. Please choose a different pickup or drop time."
      }));
      return;
    }

    setErrors({});
    handleSubmit();
  };

  return (
    <>
      {/* ✅ CSS INSIDE JSX */}
      <style>{`
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background: #fff;
  width: 95%;
  max-width: 850px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9ff;
}

.modal-header h2 {
  margin: 0;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px,1fr));
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

input, select {
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  margin-top: 4px;
  transition: 0.2s;
}

.error-input {
  border: 1px solid red;
}

input:focus, select:focus {
  border-color: #007bff;
  outline: none;
}

.modal-footer {
  padding: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #eee;
}

.btn-primary {
  background: linear-gradient(135deg, #007bff, #0056d2);
  color: white;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.btn-secondary {
  background: #ccc;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.success-text {
  color: green;
  font-size: 12px;
}

.error-text {
  color: red;
  font-size: 12px;
}

.form-notice {
  grid-column: 1 / -1;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 14px;
  color: #334155;
  font-size: 13px;
  line-height: 1.5;
}

.price-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  font-size: 12px;
  margin-top: 5px;
}

.preview-close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 30px;
  color: white;
  cursor: pointer;
  z-index: 1001;
}
@media (max-width: 600px) {
  .modal-body {
    grid-template-columns: 1fr;
  }
}
      `}</style>

      {/* UI */}
      <div className="modal-overlay">
        <div className="modal-container">

          {/* HEADER */}
          <div className="modal-header">
            <h2>Add Customer</h2>
            <button
              className="close-btn"
              onClick={() => setShowModal(false)}
            >
              ✖
            </button>
          </div>

          {/* FORM */}
          <div className="modal-body">

            {errors.general && (
              <div className="form-notice">{errors.general}</div>
            )}

            {/* NAME */}
            <div className="form-group">
              <label>Name</label>
              <input
                className={errors.fullName ? "error-input" : ""}
                value={form.fullName}
                onChange={(e) =>
                  setForm({ ...form, fullName: e.target.value })
                }
              />
              {errors.fullName && <p className="error-text">{errors.fullName}</p>}
            </div>

            {/* PHONE */}
            <div className="form-group">
              <label>Phone (10 Digits)</label>
              <input
                type="tel"
                inputMode="numeric"
                maxLength="10"
                placeholder="10-digit mobile number"
                className={errors.phone ? "error-input" : ""}
                value={form.phone}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setForm({ ...form, phone: value });
                }}
              />
              {errors.phone && <p className="error-text">{errors.phone}</p>}
            </div>

            {/* CAR */}
            <div className="form-group">
              <label>Select Car</label>

              <select
                className={errors.car ? "error-input" : ""}
                value={cars.find(c => c.name === form.car)? cars.find(c => c.name === form.car)._id : ""}
                onChange={(e) => {
                  const selectedCar = cars.find(
                    (c) => c._id === e.target.value
                  );

                  setForm({
                    ...form,
                    car: selectedCar?.name || "",
                    regNo: selectedCar?.regNo || ""
                  });
                }}
              >
                <option value="">Select Car</option>

                {cars
                  .filter((car) => car.status === "Available")
                  .map((car) => (
                    <option key={car._id} value={car._id}>
                      {car.name} ({car.regNo})
                    </option>
                  ))}
              </select>

              {errors.car && <p className="error-text">{errors.car}</p>}

              {availability?.status === "available" && (
                <p className="success-text">Available</p>
              )}

              {availability?.status === "blocked" && (
                <p className="error-text">
                  {availability.data.fullName} ({availability.data.phone}) <br />
                  {formatDateFull(availability.data.pickupDate)} →{" "}
                  {formatDateFull(availability.data.dropDate)}
                </p>
              )}
            </div>

            {/* REG */}
            <div className="form-group">
              <label>Reg No</label>
              <input value={form.regNo} readOnly />
            </div>

{/* PICKUP */}
<div className="form-group">
  <label>Pickup Date & Time</label>
  <input
    type="datetime-local"
    min={minDateTime}
    className={errors.pickupDate ? "error-input" : ""}
    value={form.pickupDate}
    onChange={(e) => {
      const value = e.target.value;

      let updatedForm = {
        ...form,
        pickupDate: value
      };

      // 🔥 अगर drop invalid हो जाए → reset
      if (
        form.dropDate &&
        parseDateTimeLocalValue(form.dropDate) <= parseDateTimeLocalValue(value)
      ) {
        updatedForm.dropDate = "";
      }

      setForm(updatedForm);
      setErrors((currentErrors) => ({
        ...currentErrors,
        pickupDate: undefined,
        dropDate: undefined,
        general: undefined
      }));
    }}
  />
  {errors.pickupDate && (
    <p className="error-text">{errors.pickupDate}</p>
  )}
</div>


{/* DROP */}
<div className="form-group">
  <label>Drop Date & Time</label>
  <input
    type="datetime-local"
    min={form.pickupDate || minDateTime}
    className={errors.dropDate ? "error-input" : ""}
    value={form.dropDate}
    onChange={(e) => {
      const value = e.target.value;

      // 🔥 HARD BLOCK (drop < pickup)
      if (
        form.pickupDate &&
        parseDateTimeLocalValue(value) <= parseDateTimeLocalValue(form.pickupDate)
      ) return;

      setForm({ ...form, dropDate: value });
      setErrors((currentErrors) => ({
        ...currentErrors,
        dropDate: undefined,
        general: undefined
      }));
    }}
  />
  {errors.dropDate && (
    <p className="error-text">{errors.dropDate}</p>
  )}
</div>

            {/* AMOUNT */}
            <div className="form-group">
              <label>Per Day Amount (₹/24hrs)</label>
              <input
                type="number"
                className={errors.amount ? "error-input" : ""}
                value={form.amount}
                onChange={(e) =>
                  setForm({ ...form, amount: e.target.value })
                }
                placeholder="e.g., 2000 for 24 hours"
              />
              {errors.amount && <p className="error-text">{errors.amount}</p>}

              {priceInfo && (
                <div style={{
                  background: "#f0f9ff",
                  border: "1px solid #0ea5e9",
                  borderRadius: 6,
                  padding: 12,
                  marginTop: 12,
                  fontSize: 13
                }}>
                  <div style={{ marginBottom: 8 }}>
                    <strong>Duration:</strong> {priceInfo.totalDays} days • {priceInfo.totalHours} hours
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <strong>Per Hour:</strong> <span style={{ color: '#0ea5e9' }}>₹{priceInfo.perHour}</span>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <strong>Per Day:</strong> <span style={{ color: '#0ea5e9' }}>₹{priceInfo.perDay}</span>
                  </div>
                  <div style={{
                    paddingTop: 8,
                    borderTop: "1px solid #0ea5e9",
                    fontWeight: 700,
                    color: '#0ea5e9',
                    fontSize: 14
                  }}>
                    Total Amount: ₹{priceInfo.totalAmount}
                  </div>
                </div>
              )}
            </div>

            {/* ADVANCE AMOUNT */}
            <div className="form-group">
              <label>Advance Amount (₹)</label>
              <input
                type="number"
                className={errors.advanceAmount ? "error-input" : ""}
                value={form.advanceAmount || ""}
                onChange={(e) => {
                  const value = e.target.value === "" ? "" : Number(e.target.value);
                  setForm({ ...form, advanceAmount: value });
                }}
                placeholder="e.g., 500"
                min="0"
              />
              {errors.advanceAmount && <p className="error-text">{errors.advanceAmount}</p>}

              {priceInfo && form.advanceAmount !== "" && (
                <div style={{
                  background: "#f0fdf4",
                  border: "1px solid #22c55e",
                  borderRadius: 6,
                  padding: 10,
                  marginTop: 10,
                  fontSize: 13
                }}>
                  <div style={{ marginBottom: 6 }}>
                    <strong>Advance:</strong> <span style={{ color: '#22c55e' }}>₹{Number(form.advanceAmount || 0).toLocaleString("en-IN")}</span>
                  </div>
                  <div style={{
                    paddingTop: 6,
                    borderTop: "1px solid #22c55e",
                    fontWeight: 700,
                    color: '#16a34a',
                    fontSize: 12
                  }}>
                    Pending: ₹{(Number(priceInfo.totalAmount) - Number(form.advanceAmount || 0)).toLocaleString("en-IN")}
                  </div>
                </div>
              )}
            </div>

            {/* FILES */}
            {[
              { label: "Aadhar Front", key: "aadharFront" },
              { label: "Aadhar Back", key: "aadharBack" },
              { label: "Licence", key: "licence" },
              { label: "Address Proof", key: "addressProof" }
            ].map((file) => {
              const hasExisting = files[file.key]?.isExisting;
              const currentFile = files[file.key];
              const isPDF = currentFile?.name?.endsWith(".pdf") || currentFile?.path?.endsWith(".pdf");
              
              return (
                <div className="form-group" key={file.key}>
                  <label>
                    {file.label}
                    {hasExisting && <span style={{ color: '#4caf50', marginLeft: 6 }}>✓ (existing)</span>}
                  </label>
                  <input
                    type="file"
                    className={errors[file.key] ? "error-input" : ""}
                    onChange={(e) => {
                      const selectedFile = e.target.files[0];
                      if (selectedFile) {
                        const reader = new FileReader();
                        reader.onload = () => {
                          setFiles({
                            ...files,
                            [file.key]: selectedFile,
                            [`${file.key}_preview`]: reader.result
                          });
                        };
                        reader.readAsDataURL(selectedFile);
                      }
                    }}
                  />
                  
                  {/* Preview for newly uploaded file */}
                  {files[`${file.key}_preview`] && !isPDF && (
                    <div style={{ marginTop: 8 }}>
                      <img
                        src={files[`${file.key}_preview`]}
                        alt="preview"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 150,
                          borderRadius: 4,
                          cursor: "pointer",
                          border: "1px solid #ddd"
                        }}
                        onClick={() => setPreview(files[`${file.key}_preview`])}
                      />
                    </div>
                  )}
                  
                  {/* Preview indicator for PDF */}
                  {files[`${file.key}_preview`] && isPDF && (
                    <div style={{ marginTop: 8, color: '#4caf50', fontSize: 12 }}>
                      📄 PDF selected: {currentFile?.name}
                    </div>
                  )}
                  
                  {/* Preview for existing document during edit */}
                  {hasExisting && currentFile?.path && !isPDF && (
                    <div style={{ marginTop: 8 }}>
                      <img
                        src={`${FILE_BASE_URL}/${currentFile.path}`}
                        alt="existing"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 150,
                          borderRadius: 4,
                          cursor: "pointer",
                          border: "1px solid #ddd"
                        }}
                        onClick={() => setPreview(`${FILE_BASE_URL}/${currentFile.path}`)}
                      />
                    </div>
                  )}
                  
                  {errors[file.key] && (
                    <p className="error-text">{errors[file.key]}</p>
                  )}
                </div>
              );
            })}

          </div>

          {/* FOOTER */}
          <div className="modal-footer">
            <button className="btn-primary" onClick={handleSave}>
              Save
            </button>

            <button
              className="btn-secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>

      {/* 🔥 IMAGE PREVIEW FULL SCREEN */}
      {preview && (
        <div
          className="modal-overlay"
          onClick={() => setPreview(null)}
          style={{ zIndex: 1001, background: "rgba(0,0,0,0.9)" }}
        >
          <img
            src={preview}
            alt="preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px"
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}